module.exports = __webpack_public_path__ + "img/terracenew_box12.b7d6279d.jpg";